module.exports = __webpack_public_path__ + "img/Photo44.8f0ee387.jpg";